<template>
  <div>
      <!-- 头部 -->
      <Headtow></Headtow>

      <div class="banner">
            <img src="/static/img/pub1.jpg" alt="" class="banner_dimg_s">
        </div>

      <div class="clear"></div>
      <div class="h-10"></div>
          <div class="clear"></div>
      <div id="w-center">
        <!-- 左侧 -->
        <div class="w-center">
          <div class="index_pub_title">
              <p class="pub_d_title">中图分类法</p>
              <router-link :to="`/index`" class="pub_duo pub_duo_d">
                 <i class="el-icon-house size-icon"></i> 首页>中图分类法
              </router-link>
              <div class="pub_xian"></div>
          </div>
          <div class="h-20"></div>
          <div class="index_left">
            <div class="xian"></div>
             <p class="china_type">中图法分类</p>
             <ul class="index_ul">
               <li class="index_ul_li" @click="typefl(0)" >全部分类</li>
               <li class="index_ul_li" v-for="(item, index) in types" :key="item.id" @click="typefl(item.id)">{{item.title}} <span>{{item.cont}}</span></li>
             </ul>
          </div>

          <div class="inde_right">
            <div class="bool_s">
                <div class="bool_s_div">
                  <div class="bool_s_tit">书号</div>
                  <el-input placeholder="请输入内容"  v-model="tm"  clearable></el-input>
                </div>
                <div class="bool_s_div">
                  <div class="bool_s_tit">书名</div>
                  <el-input placeholder="请输入内容"  v-model="title"  clearable></el-input>
                </div>
                <div class="bool_s_div">
                  <div class="bool_s_tit">出版社</div>
                  <el-input placeholder="请输入内容"  v-model="cbs"  clearable></el-input>
                </div>
                <div class="bool_s_div">
                  <div class="bool_s_tit">作者</div>
                  <el-input placeholder="请输入内容"  v-model="zz"  clearable></el-input>
                </div>
                <div class="bool_s_div">
                  <div class="bool_s_tit">出版日期</div>
                  <el-input placeholder="请输入内容"  v-model="cbrq"  clearable></el-input>
                </div>
                <div class="bool_s_div">
                  <div class="bool_s_tit">中图分类</div>
                  <el-input placeholder="请输入内容"  v-model="ztfl"  clearable></el-input>
                </div>
                <div class="bool_s_div" style="width: 400px;">
                  <div class="bool_s_tit">价格</div>
                  <el-input placeholder="请输入最小金额"  v-model="xmoney"  clearable></el-input>
                  <el-input placeholder="请输入最大金额"  v-model="dmoney"  clearable style="display: inherit;margin-left: 20px;"></el-input>
                </div>
            </div>
            <div class="bool_s">
               <div class="bool_s_tit" style="height: 30px;line-height: 30px;">出版社：</div>
               <el-checkbox-group v-model="cbsbq" class="bq_top"  >
                  <el-checkbox v-for="(item, index) in type_b"   :key="item.title"  :label="item.id">{{item.title}}</el-checkbox>
                </el-checkbox-group>


            </div>
            <div class="bool_s">
               <div class="bool_s_tit" style="height: 30px;line-height: 30px;">标签：</div>
               <el-checkbox-group v-model="bq" class="bq_top" :max="1" >
                  <el-checkbox v-for="(item, index) in bq_list"   :key="item.title"  :label="item.id">{{item.title}}</el-checkbox>
                </el-checkbox-group>

               <!-- <el-radio-group v-model="bq" class="bq_top">
                    <el-radio label="0" >反驳订单</el-radio>
                    <el-radio  v-for="(item, index) in bq_list"  :label="item.id">{{item.title}}</el-radio>
                </el-radio-group> -->


                <div @click="souqued" class="book_ss">搜索</div>
            </div>


            <ul class="tsg_ul">
              <li class="tsg_li_dz"  v-for="(item, index) in list">
                <div class="img_div">
                   <router-link :to="`/Bookcont?id=`+item.id" class="pub_duo">
                      <img src="/static/img/gbj.png" alt="" class="dz_li_img" v-if="item.picurl ==''">
                      <img :src="item.picurl" alt="" class="dz_li_img" v-else>
                      <p class="img_div_title" :title="item.title">{{item.title}}</p>
                   </router-link>
                </div>
                <div class="tj_jg" >
                  <p class="tj_money">￥{{item.old_price}}</p>
                  <p @click="handleClick(index,1)"><i class="el-icon-shopping-cart-full gwc"  ></i></p>
                </div>
              </li>
            </ul>

            <div class="page">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[20, 50,80,100]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>


            </div>


          </div>


          <div class="clear"></div>
       <!--    <el-button
             style="float: right;margin-top: 10px;margin-right: 20px;"
             type="success"
             size="small"
             @click="xz"
             >下载</el-button
           >
          <div id="products_type" style="width: 90%;">
              <el-radio-group v-model="typeid" @change="type" size="medium">
                  <el-radio-button label="0" style="float: left;" >全部</el-radio-button>
                  <div style="width: 96%;float: left;">
                   <div v-for="(item, index) in types" :key="item.id" style="display: inline-block;">
                      <el-radio-button  :label="item.id" >{{item.title}}</el-radio-button>
                   </div>
                 </div>
              </el-radio-group>


              <div v-if="orderlist !=''">
                <div class="h-20"></div>
                <el-radio-button  >反驳订单</el-radio-button>&nbsp;&nbsp;
                <el-radio-group v-model="radio" @change="radxz">
                    <el-radio label="0" >反驳订单</el-radio>
                    <el-radio  v-for="(item, index) in orderlist"  :label="item.ordernumber">{{item.ordernumber}}[{{item.create_time}}]</el-radio>
                </el-radio-group>
              </div>

              <div class="h-10"></div>
          </div> -->


        </div>
        <!-- 左侧结束 -->

      </div>

      <el-backtop :bottom="100">
          <div
            style="{
              height: 100%;
              width: 100%;
              background-color: #f2f5f6;
              box-shadow: 0 0 6px rgba(0,0,0, .12);
              text-align: center;
              line-height: 40px;
              color: #1989fa;
            }"
          >
            UP
          </div>
        </el-backtop>



      <Foot></Foot>
  </div>
</template>
<style >
    .seamless-warp2 {
        overflow: hidden;
        width: 998px;
        /* height: 200px; */
     }
    .index-tjcp-ul{width: 2220px;}
    .seamless-warp3 {
         overflow: hidden;
         width: 1200px;
         height: 70px;
     }
    /* .index-tjcp-ul1{width: 1716px;} */
</style><script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import headfor from '@/components/public/headfor.vue'
export default{
  data(){
    return {
      radio:'0',
       search: '',
      loading:true,
      list:[],
      page:1,
      total:0,
      size:20,
      info:[],
      activeName: 'first',
      ptzc:'',
      tabPosition:'1',
      types:{},
      typeid:'0',

      typetwoid:'1',
      left:{},
      keywords:'',
      typetwo:[],
      orderlist:[],

      tm:'',
      title:'',
      cbs:'',
      zz:'',
      cbrq:'',
      ztfl:'',
      keywore:'',

      bq:[],
      bq_list:[],

      type_b:[],
      cbsbq:[],

      dmoney:'',
      xmoney:'',
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Headfor': headfor,
     'Foot': foot,

  },
  mounted () {
    this.keywore = this.$route.query.keywore
    var bq = this.$route.query.bq;
    if(bq){
      this.bq = [parseInt(bq)]
    }
    var typeid = this.$route.query.typeid
    if(typeid){
      this.typeid = typeid;
    }
    var typetwoid = this.$route.query.typetwoid
    if(typetwoid){
      this.typetwoid = typetwoid
    }
    this.recordapi();
  },
  methods:{
    souqued(){
      this.type ='';
      this.keywore ='';
      this.recordapi();
    },
    xz(){
      if(this.typeid == 0){
           this.$message.error('请选择分类');
           return;
      }
      var that = this;
        window.location=process.env.API_HOST+'Goods_Classify/download?pid='+this.typeid

    },

     handleSizeChange(val) {
       this.size = val
        console.log(val);
        this.recordapi();
      },



    recordapi(){
        var that = this;
        console.log(this.cbsbq);
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Goods_Classify/index",{'dmoney':this.dmoney,'xmoney':this.xmoney,'cbsbq':this.cbsbq,'type':this.type,'bq':this.bq,'tm':this.tm,'title':this.title,'cbs':this.cbs,'zz':this.zz,'cbrq':this.cbrq,'ztfl':this.ztfl,'userid':userid,'typeid':that.typeid,'page':this.page,'keywore':this.keywore ,'size':this.size}).then(res => {
          console.log(res);
          that.types= res.type;
          that.orderlist= res.orderlist;
          that.list= res.list.data;
          that.bq_list = res.bq_list
          that.type_b = res.type_b
          this.total = res.list.total

          this.loading = false
        });
    },

    handleClick(index,e) {
      if(e == 2){
        if(this.radio=='0'){
          this.$message.error('请选择订单');
          return;
        }
      }
      var that = this;
      var row = this.list[index];
      var userid = that.$cookieStore.getCookie('userid');
      that.$api.post("/Goods/buy",{'gid':row['id'],'userid':userid,'status':'cart','gordernumber':this.radio}).then(res => {
        console.log(res);

        if(res.code==1){
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }


      });


    },




    handleInput(val){
      this.keywords = val
      // console.log(this.keywords);
      this.recordapi();
    },
    // ss(){
    //   this.handleInput();
    // },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },
    // 分类
    typefl:function(e){
      this.loading = true,
     console.log(e);
     this.keywore = '';
     this.typeid = e;

     this.recordapi();
    },
    radxz:function(e){
      console.log(e);
      this.radio = e;
    },





  }

 }
</script>
</strong>



// WEBPACK FOOTER //
// src/components/Book.vue